import { STATUS_MAP } from '@/pages/withdraw/config';
import { openNewWebview } from '@/utils/bridge';
import { BALANCE_RECORD_TYPE, INCOME_DETAILS_TYPE } from '../config';
import styles from './index.less';

export default function BalanceChangeItem({ data }) {
  const {
    type,
    orderName = '--',
    time,
    cash,
    balance,
    withdrawStatus,
    detailsType,
    detailsID,
    orderID,
  } = data;

  const handleRecordClick = () => {
    // 如果是支出，则跳转到提现详情
    if (type === BALANCE_RECORD_TYPE.EXPENDITURE) {
      openNewWebview({
        url: `${window.location.origin}/withdraw/${detailsID}`,
        title: '提现详情',
      });
    } else if (type === INCOME_DETAILS_TYPE.DEDUCTION) {
      // window.open(`${window.location.origin}/wallet/deduction/${orderID}`);
      openNewWebview({
        url: `${window.location.origin}/wallet/deduction/${orderID}`,
        title: '流水详情',
      });
    } else if (type === INCOME_DETAILS_TYPE.VAT) {
      // window.open(`${window.location.origin}/wallet/deduction/vatDetail?cash=${cash}&time=${time}`);
      openNewWebview({
        url: `${window.location.origin}/wallet/deduction/vatDetail?cash=${cash}&time=${time}`,
        title: '记录详情',
      });
    } else if (
      type === BALANCE_RECORD_TYPE.INCOME &&
      detailsType === INCOME_DETAILS_TYPE.CLOUD_BEAN
    ) {
      // window.open(`${window.location.origin}/wxMall/order/detail/${detailsID}?entrance=0`);
      openNewWebview({
        url: `${window.location.origin}/wxMall/order/detail/${detailsID}?entrance=0`,
        title: '订单详情',
      });
    }
  };

  return (
    <div
      className={`${styles['record-item']} ${styles[`type-${type}`]}`}
      onClick={handleRecordClick}
    >
      <div className={styles['record-info-wrap']}>
        <h4 className={styles.title}>
          {orderName}
          {type === BALANCE_RECORD_TYPE.EXPENDITURE && (
            <span className={`${styles['withdraw-status']} ${styles[`status-${withdrawStatus}`]}`}>
              {STATUS_MAP[withdrawStatus]}
            </span>
          )}
        </h4>
        <p className={styles.cash}>{cash}</p>
      </div>
      <div className={styles['record-info-wrap']}>
        <p className={styles['record-text']}>{time}</p>
        {!!balance && <p className={styles['record-text']}>{balance}</p>}
      </div>
    </div>
  );
}
